/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimReservationResponse } from './ClaimReservationResponse';
import {
    ClaimReservationResponseFromJSON,
    ClaimReservationResponseFromJSONTyped,
    ClaimReservationResponseToJSON,
} from './ClaimReservationResponse';

/**
 * Summary fields for a claim form search result — no decrypted formData
 * @export
 * @interface ClaimFormSearchResult
 */
export interface ClaimFormSearchResult {
    /**
     * 
     * @type {Date}
     * @memberof ClaimFormSearchResult
     */
    updatedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClaimFormSearchResult
     */
    createdAt: Date;
    /**
     * Full reservation details when linked, null when unlinked
     * @type {ClaimReservationResponse}
     * @memberof ClaimFormSearchResult
     */
    claimReservation: ClaimReservationResponse | null;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof ClaimFormSearchResult
     */
    claimReservationId: string | null;
    /**
     * The values the customer's schema flags searchable, keyed by the field they came from with one entry per
     * ticket carrying it, so a client can show a column per searchable field. Excludes sensitive fields, as
     * the search itself does. Null when the form has none, or when it was last written before the field
     * existed.
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ClaimFormSearchResult
     */
    searchableFieldValues?: { [key: string]: Array<string>; } | null;
    /**
     * Digits-only normalized secondary contact phone.
     * @type {string}
     * @memberof ClaimFormSearchResult
     */
    phoneSecondary?: string | null;
    /**
     * Digits-only normalized primary phone (e.g. "7341234567"). Clients format for display.
     * @type {string}
     * @memberof ClaimFormSearchResult
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimFormSearchResult
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimFormSearchResult
     */
    name: string;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof ClaimFormSearchResult
     */
    id: string;
}

/**
 * Check if a given object implements the ClaimFormSearchResult interface.
 */
export function instanceOfClaimFormSearchResult(value: object): value is ClaimFormSearchResult {
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('claimReservation' in value) || value['claimReservation'] === undefined) return false;
    if (!('claimReservationId' in value) || value['claimReservationId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function ClaimFormSearchResultFromJSON(json: any): ClaimFormSearchResult {
    return ClaimFormSearchResultFromJSONTyped(json, false);
}

export function ClaimFormSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimFormSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'updatedAt': (new Date(json['updatedAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'claimReservation': ClaimReservationResponseFromJSON(json['claimReservation']),
        'claimReservationId': json['claimReservationId'],
        'searchableFieldValues': json['searchableFieldValues'] == null ? undefined : json['searchableFieldValues'],
        'phoneSecondary': json['phoneSecondary'] == null ? undefined : json['phoneSecondary'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'email': json['email'] == null ? undefined : json['email'],
        'name': json['name'],
        'id': json['id'],
    };
}

export function ClaimFormSearchResultToJSON(value?: ClaimFormSearchResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'updatedAt': ((value['updatedAt']).toISOString()),
        'createdAt': ((value['createdAt']).toISOString()),
        'claimReservation': ClaimReservationResponseToJSON(value['claimReservation']),
        'claimReservationId': value['claimReservationId'],
        'searchableFieldValues': value['searchableFieldValues'],
        'phoneSecondary': value['phoneSecondary'],
        'phone': value['phone'],
        'email': value['email'],
        'name': value['name'],
        'id': value['id'],
    };
}

